// src/components/FeedPostCard.jsx

import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const FeedPostCard = ({ postId, type, title, author, date, initialComments, initialUpvotes, content }) => {
    
    // State to manage real-time interactions (upvotes)
    const [upvotes, setUpvotes] = useState(initialUpvotes);
    const [isUpvoted, setIsUpvoted] = useState(false);

    const handleUpvote = () => {
        if (!isUpvoted) {
            setUpvotes(upvotes + 1);
        } else {
            setUpvotes(upvotes - 1);
        }
        setIsUpvoted(!isUpvoted);
    };

    // Determine the color of the post type tag
    let typeColor;
    if (type === 'ALERT') {
        typeColor = 'var(--color-error)';
    } else if (type === 'DISCUSSION') {
        typeColor = 'var(--color-sky)';
    } else {
        typeColor = 'var(--color-navy)';
    }

    return (
        <div className="feed-post-card" style={{ 
            border: '1px solid #e0e0e0', 
            padding: '25px', 
            borderRadius: '10px', 
            marginBottom: '20px', 
            backgroundColor: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
            {/* Header: Type and Metadata */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <span className="post-type-tag" style={{ 
                    fontWeight: 'bold', 
                    color: typeColor, 
                    border: `1px solid ${typeColor}`,
                    padding: '3px 8px',
                    borderRadius: '4px',
                    fontSize: '0.8rem',
                    textTransform: 'uppercase'
                }}>
                    {type}
                </span>
                <span style={{ fontSize: '0.85rem', color: 'var(--color-gray-medium)' }}>
                    Posted by: <RouterLink to={`/app/user/${author}`} style={{ color: 'var(--color-navy)', textDecoration: 'none', fontWeight: 'bold' }}>{author}</RouterLink> | {date}
                </span>
            </div>

            {/* Title and Content */}
            <h3 style={{ margin: '0 0 15px 0', fontSize: '1.4rem', color: 'var(--color-navy)' }}>{title}</h3>
            <p style={{ fontSize: '1rem', color: 'var(--color-gray-dark)', lineHeight: '1.5' }}>{content}</p>

            {/* Action Bar (Footer) */}
            <div className="post-actions" style={{ display: 'flex', gap: '20px', fontSize: '0.9rem', marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #eee' }}>
                
                {/* Upvote Button */}
                <button 
                    onClick={handleUpvote} 
                    style={{ 
                        background: 'none', 
                        border: 'none', 
                        color: isUpvoted ? 'var(--color-sky)' : 'var(--color-gray-medium)',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'color 0.2s'
                    }}
                >
                    <span style={{ marginRight: '5px' }}>[Arrow Up]</span> 
                    {upvotes} Upvotes
                </button>

                {/* Comment Link */}
                <RouterLink 
                    to={`/app/post/${postId}`} 
                    style={{ 
                        color: 'var(--color-gray-medium)', 
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <span style={{ marginRight: '5px' }}>[Chat Bubble]</span>
                    {initialComments} Comments
                </RouterLink>

                {/* Share Action */}
                <button 
                    onClick={() => alert('Post shared!')} 
                    style={{ 
                        background: 'none', 
                        border: 'none', 
                        color: 'var(--color-gray-medium)',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    [Share Icon] Share
                </button>
            </div>
        </div>
    );
};

export default FeedPostCard;